import { environment } from 'src/environments/environment';

export const ConstantsRotasDoSistema = {
    DEFAULT_PATH: '/',
    LOGIN: 'login',
    RESET_PASSWORD: 'reset-password',
    ALTERAR_SENHA: 'alterar-senha',
    ACEITE_DE_TERMOS: 'aceite-de-termos',
    ACESSO_PESSOAL: 'acesso-pessoal',
    ACESSOS: 'acessos',
    ADM_LICENCAS: 'adm/licencas',
    AUTOCADASTRO: 'autocadastro',
    CLIENTES: 'clientes',
    DASHBOARD: 'dashboard',
    EQUIPES: 'equipes',
    LICENCAS: 'licencas',
    APRESENTACAO: 'apresentacao-sistema',
    GRUPOS_LICENCAS: 'licencas/grupo',
    PLAY: 'play',
    RELATORIOS: environment.URL_SISTEMA + '/relatorio',
    DEVOLUTIVA: 'devolutiva',
    RELATORIOS_SISTEMA: 'relatorios',
    COMPARACAO_RELATORIOS: 'comparacao-relatorio',
    SKINS: 'skins',
    TERMOS_DE_USO: 'termos-de-uso',
    TESTES: 'testes',
    RECOMENDACOES: 'recomendacoes',
    ADMIN_EMAILS: 'admin/emails'
}